import React from 'react';
import './PrivacyBody.css';

const PrivacyBody = () => {

    return (
        <section className="section privacy-body">
            <div className="container">
                <div className="terms-content paragraph color-darkblue">

                    <h1>A NOTICE ON RECRUITMENT SCAMS</h1>
                    
                    <p>At Hudson Pacific Properties, Sunset Studios and Quixote, we are committed to maintaining transparency and integrity throughout our hiring process. It has recently come to our attention that individuals claiming to be representatives of Hudson Pacific Properties, Sunset Studios or Quixote have been engaging in fraudulent recruitment practices. These individuals are targeting potential candidates through deceptive emails and social media platforms, claiming to act on our behalf, offering fictitious job opportunities, and requesting personal information.</p>

                    <p>To safeguard your personal information and ensure the legitimacy of job offers, we urge you to take the following precautions:</p>

                    <ul>
                        <li><b>Consult our official career websites:</b> All legitimate job openings at <a href='/careers' target='_blank'>Hudson Pacific Properties</a>, <a href='https://www.sunsetstudios.com/los-angeles/careers/' target='_blank'>Sunset Studios</a> and <a href='https://www.quixote.com/careers/' target='_blank'>Quixote</a> are posted on their respective career websites.</li>
                        <li><b>Direct applications:</b> If you receive a communication regarding a job offer, please verify its authenticity by checking our career website directly. Applications should only be submitted through our website.</li>
                        <li><b>Do not share personal information:</b> If you are uncertain about the legitimacy of a communication that claims to be from our organization, refrain from sharing any personal information.</li>
                        <li><b>Report suspicious activity:</b> If you encounter any suspicious communications or individuals claiming to represent our studios, please report these incidents to our People & Culture department at <a href='mailto:peopleandculture@hudsonppi.com' target='_blank'>peopleandculture@hudsonppi.com</a></li>
                    </ul>
                    
                    <p>We take these matters very seriously and are actively working to combat recruitment fraud. Your security and trust are paramount to us. We appreciate your vigilance and encourage you to remain cautious in all job-related communications.</p>
                </div>
            </div>
        </section>

    );
};

export default PrivacyBody;
